import MaterialTable from "@material-table/core";
import _ from "lodash";
import useFilterState from "../../../hooks/useFilterState";

const AuditMaterialTable = (props) => {
  const { tableName, tableRef, columns, tableData } = props;

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <MaterialTable
      tableRef={tableRef}
      localization={{
        body: {
          emptyDataSourceMessage: (
            <h6 className="left-[45%] absolute top-[40%] text-center">
              No records to display
            </h6>
          ),
        },
        pagination: {
          labelRowsPerPage: "Orders Per Page",
          labelRowsSelect: "Orders",
        },
      }}
      title="Audit Data Table"
      columns={columnsWithFilter.map((col, index) => {
        if (
          col.tableData?.filterValue == "" ||
          col.tableData?.filterValue == null ||
          col.tableData?.filterValue == undefined
        ) {
          let colWithoutDefaultFilter = _.omit(
            col,
            "defaultFilter",
            "tableData.filterValue"
          );
          return colWithoutDefaultFilter;
        } else {
          return {
            ...col,
            defaultFilter: col.tableData?.filterValue,
          };
        }
      })}
      data={tableData}
      onFilterChange={(filters) => {
        // Create a map of current filters for quick lookup
        const filterMap = new Map();
        filters.forEach((filter) => {
          filterMap.set(filter.column.tableData.id, filter.value);
        });

        // Iterate over all columns to ensure each one is checked if the value is present in the filter map
        columns.forEach((col, columnId) => {
          const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

          // Update the filter state for each column
          handleFilterChange(columnId, newValue);
        });
      }}
      options={{
        rowStyle: {
          fontSize: 10,
        },
        selection: false,
        search: false,
        showTitle: false,
        grouping: false,
        pageSize: 100,
        toolbar: false,
        filtering: true,
        draggable: false,
        maxBodyHeight: 600,
        headerStyle: {
          backgroundColor: "#367c2b",
          fontWeight: "400",
          color: "white",
          position: "sticky",
          top: 0,
          zIndex: 10,
        },
        tableContainerStyle: {
          maxHeight: 600,
          overflow: "auto",
        },
        pageSizeOptions: [100, 500, 1000],
        actionsColumnIndex: -1,
        filterCellStyle: {
          flex: 1,
        },
      }}
    />
  );
};
export default AuditMaterialTable;
